module.exports = __webpack_public_path__ + "static/media/Videographers.4f9845d1.png";